module.exports = __webpack_public_path__ + "img/axel-ruessmeyer.84f699c5.png";